module.exports = __webpack_public_path__ + "img/ico-paragraph-disabled.dd110720.svg";